export const SiteDocument: any = [
    {
        id : 1661,
        documentName: "NDA.PDF",
    },
    {
        id : 1662,
        documentName: "MVA.PDF",

    },
    {
        id : 1663,
        documentName: "GFSI.PDF",

    },
    {
        id : 1664,
        documentName: "W-8BEN-E.PDF",
    }
]